import estadoPillStyle from "assets/jss/material-dashboard-pro-react/estadoPillStyle.jsx";
import {primaryColor} from "assets/jss/material-dashboard-pro-react.jsx";
import buttonStyle from "../components/buttonStyle";

const formacaoContinuaStyle = {
  ...estadoPillStyle,
  ...buttonStyle,
  creditosCard: {
    textAlign: "center",
    height: "100%",
    marginTop: 0,
    marginBottom: 0,
    "& span": {
      color: "gray"
    },
    "& h4": {
      fontWeight: "400",
      lineHeight: "1",
      fontSize: "1.5em",
      margin: "auto"
    },
    "& > div": {
      display: "flex",
      flexDirection: "column"
    }
  },

  // ---- Percursos section ----
  sectionTitle: {
    fontWeight: 500,
    fontSize: "1.35em",
    marginTop: 0,
    marginBottom: 14,
    color: "#3C4858"
  },
  percursoPanel: {
    marginBottom: "0 !important",
    borderRadius: "0 !important",
    boxShadow: "none !important",
    border: "1px solid #e8e8e8",
    borderBottom: "none",
    "&:first-child": {
      borderRadius: "3px 3px 0 0 !important"
    },
    "&:last-child": {
      borderRadius: "0 0 3px 3px !important",
      borderBottom: "1px solid #e8e8e8"
    },
    "&.Mui-expanded": {
      margin: "0 !important"
    }
  },
  percursoSummaryRoot: {
    // Green left border always present — on the summary row only,
    // so when the panel expands the Details below don't carry it.
    borderLeft: "4px solid " + primaryColor,
    padding: "0 24px",
    minHeight: "64px !important",
    "@media (max-width: 600px)": {
      padding: "0 14px"
    }
  },
  percursoSummary: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: "14px 0",
    gap: "18px",
    "@media (max-width: 600px)": {
      flexWrap: "wrap",
      gap: "6px 10px"
    }
  },
  percursoDesignacao: {
    fontWeight: 500,
    fontSize: "1em",
    whiteSpace: "nowrap",
    width: "320px",
    minWidth: "320px",
    color: "#3C4858",
    "& strong": {
      color: "" + primaryColor,
      fontWeight: 700,
      marginRight: 8
    },
    "@media (max-width: 600px)": {
      width: "auto",
      minWidth: "auto",
      flex: "1",
      fontSize: "0.95em"
    }
  },
  progressBarContainer: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    gap: "12px",
    "@media (max-width: 600px)": {
      flex: "1 1 100%",
      order: 3
    }
  },
  progressBar: {
    flex: 1,
    height: 10,
    borderRadius: 5,
    backgroundColor: "#e0e0e0",
    "& .MuiLinearProgress-bar": {
      borderRadius: 5,
      backgroundColor: "" + primaryColor
    }
  },
  percentagem: {
    fontSize: "1.05em",
    fontWeight: 600,
    color: "#555",
    minWidth: "56px",
    width: "56px",
    textAlign: "right"
  },

  // ---- Estado Badge ----
  estadoBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "6px",
    fontSize: "0.82em",
    fontWeight: 400,
    textTransform: "uppercase",
    letterSpacing: "0.2px",
    whiteSpace: "nowrap",
    color: "#9F9F9F",
    minWidth: "118px",
    width: "118px",
    boxSizing: "border-box",
    "& svg": {
      fontSize: 13
    },
    "@media (max-width: 600px)": {
      order: 2,
      fontSize: "0.78em",
      padding: "2px 6px"
    }
  },
  estadoApto: {
    "& svg": {color: "#2e7d32"}
  },
  estadoNaoApto: {
    "& svg": {color: "#c62828"}
  },
  estadoInscrito: {
    "& svg": {color: "#1565c0"}
  },
  estadoTerminado: {
    color: "#9e9e9e",
    "& svg": {color: "#9e9e9e"}
  },

  // ---- Expanded content ----
  percursoContent: {
    display: "block",
    padding: "16px 24px 20px !important",
    width: "100%",
    "@media (max-width: 600px)": {
      padding: "14px 14px 18px !important"
    }
  },
  percursoContentTop: {
    display: "flex",
    alignItems: "center",
    marginBottom: 18,
    gap: 16
  },
  tabList: {
    display: "inline-flex",
    backgroundColor: "#f0f0f0",
    borderRadius: 6,
    gap: 2,
    height: "32px"
  },
  tabButton: {
    padding: "6px 18px",
    borderRadius: 4,
    fontSize: "0.85em",
    fontWeight: 500,
    color: "#999",
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    transition: "background-color 0.15s ease, color 0.15s ease",
    whiteSpace: "nowrap",
    "&:hover": {
      color: "#3C4858"
    },
    "&:focus": {
      outline: "none"
    }
  },
  tabButtonActive: {
    backgroundColor: "" + primaryColor,
    color: "#fff !important",
    fontWeight: 600,
    boxShadow: "0 1px 2px rgba(0,0,0,0.12)",
    "&:hover": {
      color: "#fff",
      backgroundColor: "#43a047"
    }
  },
  modulosCounter: {
    fontSize: "0.88em",
    color: "#666",
    fontWeight: 500,
    marginLeft: "auto",
    whiteSpace: "nowrap",
    minWidth: "132px",
    width: "132px",
    textAlign: "right"
  },

  // ---- Module rows ----
  moduloRow: {
    display: "flex",
    alignItems: "center",
    padding: "12px 0",
    borderBottom: "1px solid #f0f0f0",
    "&:last-child": {
      borderBottom: "none"
    },
    "@media (max-width: 600px)": {
      padding: "10px 0"
    }
  },
  moduloIcon: {
    marginRight: "14px",
    minWidth: "22px",
    display: "flex",
    alignItems: "center"
  },
  moduloNome: {
    flex: 1,
    fontSize: "0.92em",
    fontWeight: 400,
    color: "#444",
    "@media (max-width: 600px)": {
      fontSize: "0.86em"
    }
  },

  // ---- Footer of expanded panel ----
  inscreverWrapper: {
    display: "flex",
    justifyContent: "center",
    marginTop: 18
  },
  inscreverButton: {
    backgroundColor: "#bdbdbd !important",
    color: "#fff !important",
    textTransform: "none !important",
    boxShadow: "none !important",
    padding: "10px 28px !important",
    borderRadius: "6px !important",
    fontSize: "0.9em !important",
    fontWeight: "500 !important",
    "&:hover": {
      backgroundColor: "#9e9e9e !important"
    }
  },
  faltamModulos: {
    textAlign: "center",
    marginTop: 10,
    fontSize: "0.88em",
    color: "#e65100",
    fontStyle: "italic",
    "& strong": {
      fontWeight: 600,
      fontStyle: "normal"
    }
  },

  // ---- Catálogo de Módulos ----
  sectionCard: {
    backgroundColor: "#fff",
    borderRadius: 8,
    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
    overflow: "hidden",
    marginBottom: 16
  },
  moduloPanel: {
    marginBottom: "0 !important",
    borderRadius: "0 !important",
    boxShadow: "none !important",
    border: "1px solid #e8e8e8",
    borderBottom: "none",
    "&:first-child": {
      borderRadius: "8px 8px 0 0 !important"
    },
    "&:last-child": {
      borderRadius: "0 0 8px 8px !important",
      borderBottom: "1px solid #e8e8e8"
    },
    "&.Mui-expanded": {
      margin: "0 !important"
    }
  },
  moduloSummaryRoot: {
    padding: "0 18px",
    minHeight: "58px !important"
  },
  moduloSummary: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: 4,
    padding: "10px 0"
  },
  moduloCodigoDesignacao: {
    fontSize: "0.95em",
    color: "#3C4858",
    minHeight: "2.7em",
    lineHeight: 1.35,
    "& strong": {
      color: "" + primaryColor,
      fontWeight: 700,
      marginRight: 6
    }
  },
  moduloMeta: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    fontSize: "0.82em",
    color: "#888"
  },
  moduloMetaEstado: {
    fontSize: "1em",
    fontWeight: 700,
    padding: "4px 14px"
  },
  moduloMetaSeparador: {
    color: "#ccc"
  },
  moduloMetaDot: {
    display: "inline-block",
    width: 8,
    height: 8,
    borderRadius: "50%",
    marginRight: 4,
    verticalAlign: "middle"
  },
  moduloMetaDotVerde: {
    backgroundColor: "" + primaryColor
  },
  moduloMetaDotCinza: {
    backgroundColor: "#bdbdbd"
  },
  moduloContent: {
    display: "block",
    padding: "12px 18px 18px !important",
    width: "100%",
    backgroundColor: "#fafafa"
  },
  datasDisponiveisTitulo: {
    fontSize: "0.88em",
    fontWeight: 600,
    color: "#3C4858",
    marginBottom: 10
  },
  formacaoRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 0",
    borderBottom: "1px solid #eee",
    "&:last-child": {
      borderBottom: "none"
    }
  },
  formacaoRowText: {
    flex: 1,
    fontSize: "0.92em",
    color: "#444",
    "& > div:first-child": {
      fontWeight: 500,
      color: "#3C4858"
    },
    "& > div:last-child": {
      color: "#888",
      fontSize: "0.92em",
      marginTop: 3
    }
  },
  formacaoToggle: {
    border: "1px solid #e0e0e0",
    backgroundColor: "#fff",
    borderRadius: "50%",
    width: 36,
    height: 36,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    color: "" + primaryColor,
    fontSize: "0.95em",
    boxShadow: "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.08)",
    transition: "background-color 0.15s ease, box-shadow 0.15s ease",
    "&:hover": {
      backgroundColor: "#f5f5f5",
      boxShadow: "0 2px 5px rgba(0,0,0,0.15), 0 1px 3px rgba(0,0,0,0.1)"
    },
    "&:focus": {
      outline: "none"
    }
  },
  formacaoDetalhes: {
    backgroundColor: "#f0f0f0",
    borderRadius: 6,
    padding: "14px 16px",
    marginTop: 6,
    marginBottom: 6
  },
  detalhesGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    columnGap: 14,
    rowGap: 8,
    marginBottom: 12
  },
  detalhesLinha: {
    display: "flex",
    gap: 8,
    fontSize: "0.92em"
  },
  detalhesLabel: {
    color: "#777",
    minWidth: 60,
    whiteSpace: "nowrap"
  },
  detalhesValue: {
    color: "#3C4858",
    fontWeight: 600
  },
  verFormacaoWrapper: {
    display: "flex",
    justifyContent: "center",
    marginTop: 4
  },
  verFormacaoButton: {
    backgroundColor: primaryColor + " !important",
    color: "#fff !important",
    textTransform: "none !important",
    boxShadow: "none !important",
    padding: "5px 20px !important",
    minHeight: "0 !important",
    borderRadius: "6px !important",
    fontSize: "0.88em !important",
    fontWeight: "500 !important",
    "&:hover": {
      backgroundColor: "#43a047 !important"
    }
  },
  catalogoVazio: {
    padding: "18px",
    textAlign: "center",
    color: "#999",
    fontSize: "0.9em"
  },

  // ---- Tabela do catálogo: esconde expander automático do react-table ----
  catalogoTable: {
    "& .rt-expander": {
      display: "none !important"
    },
    "& .rt-expandable": {
      display: "none !important",
      width: "0 !important",
      padding: "0 !important"
    },
    "& .rt-td": {
      padding: 0,
      border: "none"
    },
    "& .rt-tr": {
      border: "none"
    },
    "& .rt-thead": {
      display: "none"
    }
  },
  // ---- Linha de catálogo (card row) ----
  catalogoRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: 12,
    padding: "12px 16px",
    background: "#fff",
    cursor: "pointer"
  },
  catalogoRowMain: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: 6
  },
  catalogoRowTitulo: {
    fontSize: "14px",
    fontWeight: 400,
    color: "#444",
    lineHeight: 1.3
  },
  // Título verde quando expandido.
  catalogoRowTituloExpandido: {
    color: "#009538",
    "& strong": {color: "#009538"}
  },
  catalogoRowMeta: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 6,
    fontSize: "13px",
    color: "#555"
  },
  catalogoMetaSep: {
    color: "#999"
  },
  catalogoChevron: {
    background: "transparent",
    border: "none",
    cursor: "pointer",
    padding: 6,
    color: "#555",
    fontSize: "1em",
    "&:hover": {color: "#000"}
  },

  // ---- Dirigentes — Gráficos ----
  dirigentesSection: {
    marginTop: 0,
    marginBottom: 20
  },
  dirigentesOuterCard: {
    boxShadow: "none",
    border: "1px solid #e8e8e8",
    borderRadius: 8,
    margin: 0,
    backgroundColor: "#fff"
  },
  dirigentesOuterCardBody: {
    padding: "16px !important"
  },
  dirigentesGridItem: {
    marginBottom: "24px !important",
    "@media (max-width: 959px)": {
      marginBottom: "18px !important"
    }
  },
  dirigentesCard: {
    backgroundColor: "#F4F4F4",
    borderRadius: 8,
    padding: "20px 16px",
    textAlign: "center",
    height: "100%",
    display: "flex",
    flexDirection: "column"
  },
  dirigentesCardTitle: {
    fontWeight: 700,
    fontSize: "1.2em",
    color: "#3C4858",
    marginBottom: 14
  },
  dirigentesChartContainer: {
    position: "relative",
    zIndex: 1,
    maxWidth: 240,
    margin: "0 auto 16px"
  },
  dirigentesLegend: {
    textAlign: "left",
    padding: "0 8px"
  },
  dirigentesLegendItem: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "8px 0",
    fontSize: "0.9em",
    color: "#555"
  },
  dirigentesLegendDivider: {
    height: 1,
    backgroundColor: "#e0e0e0"
  },
  dirigentesLegendDot: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    flexShrink: 0
  },
  dirigentesLegendLabel: {
    flex: 1
  },
  dirigentesLegendValues: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    whiteSpace: "nowrap"
  },
  dirigentesLegendSep: {
    color: "#999",
    fontWeight: 400
  },

  // ---- Dirigentes — Lista ----
  listaDirigentesSection: {
    marginTop: 24,
    marginBottom: 20,
    "& .card-header": {
      marginBottom: 0
    },
    "& .card-body, & .card": {
      boxShadow: "none"
    },
    "& .ReactTable": {
      border: "none",
      fontSize: "14px",
      color: "#3C4858"
    },
    "& .ReactTable .rt-thead.-header": {
      boxShadow: "none",
      borderBottom: "1px solid #ececec",
      backgroundColor: "#fff"
    },
    "& .ReactTable .rt-th": {
      borderRight: "none",
      padding: "12px 10px",
      display: "flex",
      alignItems: "center",
      fontSize: "16px",
      fontWeight: 400,
      color: "#4b4b4b"
    },
    "& .ReactTable .rt-th:first-child": {
      justifyContent: "flex-start",
      paddingLeft: 28
    },
    "& .ReactTable .rt-th:last-child": {
      paddingRight: 22
    },
    "& .ReactTable .rt-thead.-header .rt-tr": {
      minHeight: 64,
      alignItems: "center"
    },
    "& .ReactTable .rt-tbody .rt-td": {
      borderRight: "none"
    },
    "& .ReactTable .rt-tbody .rt-tr-group": {
      borderBottom: "1px solid #efefef"
    }
  },
  listaExportButton: {
    backgroundColor: "#00923F !important",
    color: "#fff !important",
    textTransform: "none !important",
    boxShadow: "none !important",
    height: 38,
    minHeight: "38px !important",
    padding: "0 16px !important",
    borderRadius: "4px !important",
    fontSize: "0.88em !important",
    fontWeight: "500 !important",
    "&:hover": {
      backgroundColor: "#007A35 !important"
    }
  },
  listaExportButtonInner: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    lineHeight: 1
  },
  listaExpanded: {
    padding: "14px 16px",
    backgroundColor: "#fafafa",
    borderBottom: "1px solid #f0f0f0"
  },
  listaExpandedRow: {
    display: "flex",
    alignItems: "center",
    padding: "10px 0",
    gap: 12,
    fontSize: "0.95em",
    "&:not(:last-child)": {
      borderBottom: "1px dashed #e0e0e0"
    }
  },
  listaExpandedCodigo: {
    minWidth: 260,
    flex: "0 0 260px",
    fontSize: "0.95em",
    color: "#3C4858",
    "& strong": {
      color: "" + primaryColor,
      fontWeight: 700,
      marginRight: 6
    }
  },
  listaExpandedProgresso: {
    flex: "1 1 0",
    minWidth: 0,
    display: "flex",
    alignItems: "center",
    gap: 10
  },
  listaExpandedPercentagem: {
    minWidth: 56,
    width: 56,
    textAlign: "right",
    fontSize: "0.95em",
    fontWeight: 600,
    color: "#555"
  },
  listaExpandedModulos: {
    minWidth: 170,
    width: 170,
    flex: "0 0 170px",
    color: "#666",
    fontSize: "0.95em",
    textAlign: "left"
  },
  listaVazia: {
    padding: "24px",
    textAlign: "center",
    color: "#999",
    fontSize: "0.9em"
  }
};

export default formacaoContinuaStyle;
